import { addB2bAPIParams } from '../b2b';
import { restrictMainCurrency } from '../shopify-market/restrict-user.js';
import { addParamsLocale, getCustomerId, getTenantId } from '../utils';
import { saveRequestId } from '.';

/**
 * @type {import('./index.d').predictiveBundleByProductId}
 */
export const predictiveBundleByProductId = async (context, productId) => {
  if (!productId) return [];

  let params = {
    product_id: productId,
    shop: getTenantId(),
    country: window.Shopify.country || '',
    customer_id: getCustomerId(),
  };

  params = addParamsLocale(params);

  if (context.app.b2b?.enabled) {
    addB2bAPIParams(params, context);
  }

  const queryParams = new URLSearchParams(params);

  const response = await fetch(`${context?.app?.bundleUrl}?${queryParams.toString()}`);
  if (response.status === 200) {
    const data = await response.json();

    if (data.meta) {
      const { money_format, money_format_with_currency, currency } = data.meta;
      restrictMainCurrency(context, { money_format, money_format_with_currency, currency });
    }

    saveRequestId('product_page_bundle', data.meta?.rid, data?.bundles);
    return data?.bundles || [];
  }

  return [];
};

export const volumeBundleByProductId = async (context, productId) => {
  if (!productId) return [];

  let params = {
    product_id: productId,
    shop: getTenantId(),
    country: window.Shopify.country || '',
    customer_id: getCustomerId(),
  };

  params = addParamsLocale(params);

  if (context.app.b2b?.enabled) {
    addB2bAPIParams(params, context);
  }

  const queryParams = new URLSearchParams(params);

  const response = await fetch(`${context?.app?.bundleUrl}?${queryParams.toString()}`);
  if (response.status === 200) {
    const data = await response.json();

    if (data.meta) {
      const { money_format, money_format_with_currency, currency } = data.meta;
      restrictMainCurrency(context, { money_format, money_format_with_currency, currency });
    }

    saveRequestId('product_page_volume_bundle', data.meta?.rid, data?.bundles);
    return data?.bundles || [];
  }

  return [];
};
